export default __webpack_public_path__ + "static/media/instagram.8f670061.svg";